export default "__VITE_ASSET__3EEfvl3w__"